/**
 * Cấp ngân sách
 */
export default {
    AllProvince: 1,
    Province: 2,
    District: 3,
  };
  